export default "__VITE_ASSET__VyPaMh9B__"